import React, { useState } from "react";

import { TableComponent } from "../components/TableComponent";
import { Button } from "V2.0/common/button";
import { Dialog, DialogTitle, DialogActions } from "V2.0/common/dialog";
import { DialogTitleWithClose } from "../components/Dialog/DialogTitleWithClose";

export function ExistingAPIs({ customApis, setActiveItem, onDelete, locked }) {
  const [isOpen, setIsOpen] = useState(false);
  const [item, setItem] = useState(null);

  const nameById = new Map(customApis.map((a) => [String(a._id), a.apiName]));

  const rows = customApis.map((api) => {
    const followUpCount = Array.isArray(api.sequenceAPIIds) ? api.sequenceAPIIds.length : 0;
    const triggeredBy = customApis
      .filter(
        (other) =>
          other._id !== api._id &&
          Array.isArray(other.sequenceAPIIds) &&
          other.sequenceAPIIds.includes(api._id)
      )
      .map((other) => other.apiName);

    const activatorNames = (Array.isArray(api.activationAPIIds) ? api.activationAPIIds : [])
      .map((id) => nameById.get(String(id)))
      .filter(Boolean);

    const hints = [];
    if (triggeredBy.length > 0) hints.push(`Runs after: ${triggeredBy.join(", ")}`);
    if (activatorNames.length > 0) hints.push(`Waits for: ${activatorNames.join(", ")}`);
    if (followUpCount > 0) hints.push(`${followUpCount} follow-up${followUpCount > 1 ? "s" : ""}`);
    const sequenceHint = hints.join(" · ");

    return { ...api, sequenceHint };
  });

  return (
    <>
      <TableComponent
        data={rows}
        headers={[
          { key: "apiName", label: "Name" },
          { key: "apiURL", label: "URL" },
          { key: "apiMethod", label: "Method" },
          { key: "sequenceHint", label: "Sequence" },
        ]}
        onEdit={setActiveItem}
        showActions={!locked}
        onDelete={(item, index) => {
          setIsOpen(true);
          setItem(item);
        }}
      />

      <Dialog open={isOpen} onClose={() => setIsOpen(false)}>
        <DialogTitle>Delete Custom API</DialogTitle>
        <DialogActions>
          <Button outline onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              onDelete(item._id);
              setIsOpen(false);
            }}
          >
            Yes, delete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
